import React from 'react';

import Modal from '~/components-ds/Modal';
import { useAppContent } from '~/hooks';

export interface SearchModalProps {
  closeModal: () => void;
  children: React.ReactElement;
}

const OccupationSelectorSearchModal: React.FC<SearchModalProps> = ({ closeModal, children }) => {
  const { getTextContent: getSharedContent } = useAppContent({
    basePath: 'shared',
  });

  const { getTextContent } = useAppContent({
    basePath: 'dsme.businessDetailsOccupancySearch.fields',
  });
  return (
    <Modal
      open
      id="occupation-selector-search-modal"
      data-testid="occupation-selector-search-modal"
      title={`${getTextContent('iconSearchExactOccupation.titlePrefix')}${getTextContent(
        'iconSearchExactOccupationSearchModal.title'
      )}`}
      primaryBtnProps={{
        label: getSharedContent('cancelModalButtonLabel'),
        onClick: closeModal,
      }}
    >
      {children}
    </Modal>
  );
};

export default OccupationSelectorSearchModal;
